import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'

export const _PlaceIcon = styled.div`
  transform: translate(-50%, -50%);
  border: 2px solid #d3d3d3;
  border-radius: 50%;
  cursor: pointer;
  background-color: #f8f8f8;
  position: relative;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    fill: #707070;
  }
  &.transit-busMarker { border-color: #5bdad6; }
  &.transit-streetcarMarker { border-color: #8b36c7; }
  &.transit-subwayMarker { border-color: orange; }
  &.transit-trainMarker { border-color: #87ca21; }
  &.transit-ferryMarker { border-color: #0093ff; }

  &.amenities-marker-bars-restosMarker,
  &.amenities-marker-groceryMarker,
  &.amenities-marker-schoolMarker {
    border-color: #5bdad6;

    svg {
      fill: transparent;
      stroke: #707070;
      path {
        stroke: #707070;
      }
    }
  }
`
